import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthenticationManager from './components/auth/AuthenticationManager';

const validateEnvironment = () => {
    const requiredVars = ['REACT_APP_API_URL']; // Remove REACT_APP_ALLOWED_ORIGINS if not needed
    const missing = requiredVars.filter(varName => !process.env[varName]);
    if (missing.length > 0) {
        console.error('Missing required environment variables:', missing);
        console.log('Current environment:', process.env.NODE_ENV);
        console.log('Available REACT_APP_ variables:',
            Object.keys(process.env)
                .filter(key => key.startsWith('REACT_APP_'))
                .reduce((acc, key) => ({ ...acc, [key]: process.env[key] }), {})
        );
        return false;
    }
    return true;
};

// Validate environment before rendering
if (!validateEnvironment()) {
    console.error('Environment validation failed. Please check your .env configuration.');
}

//ReactDOM.render(
//    <React.StrictMode>
//        <App />
//    </React.StrictMode>,
//    document.getElementById('root')
//);
// Example in index.tsx or main entry point

ReactDOM.render(
    <React.StrictMode>
        <AuthenticationManager>
            <App />
        </AuthenticationManager>
    </React.StrictMode>,
    document.getElementById('root')
);

reportWebVitals();